import { createContext, useContext } from 'react';

export const HeaderShellContext = createContext<HTMLDivElement | null>(null);

export const useHeaderShellContext = () => useContext(HeaderShellContext);
